import React from "react";
import { useTranslation } from 'react-i18next';

/**
 *
 */
export default function Foot
    () {
    const { t, i18n } = useTranslation();

    const personalDataLink = i18n.resolvedLanguage === 'sv' ? 'https://www.uu.se/student/studentliv/studentekonomi/stipendier/behandling-av-personuppgifter' : 'https://www.uu.se/en/students/student-life/student-finance/scholarships/processing-of-personal-data';

    return (
        <footer className="layout-footer">
            <div className="layout-footer-bg-img"></div>
            <div className="container">

                <div className="row layout-footer-last-row">
                    <div className="col-12">
                        <article className="footer-site-information" aria-label={t('footer.aria-label')}>
                            <address>
                                <span className="footer-site-entry">© {t('footer.university')}</span> 
                                <span className="footer-site-entry">{t('footer.telephone_title')}
                                    <span className="tel">{t('footer.telephone_number')}</span>
                                </span> 
                                <span className="footer-site-entry">{t('footer.box')}</span>
                            </address>
                            <p>
                                <span className="footer-site-entry">{t('footer.registration_number')}</span> 
                                <span className="footer-site-entry">{t('footer.vat_number')}</span> 
                                <span className="footer-site-entry">{t('footer.pic')}</span> 
                                <span className="footer-site-entry">
                                    <a href={t('footer.registrar_url')}>{t('footer.registrar')}</a>
                                </span> 
                                <span className="footer-site-entry">
                                    <a href={t('footer.about_this_website_url')}>{t('footer.about_this_website')}</a>
                                </span> 
                                <span className="footer-site-entry">
                                    <a href={t('footer.privacy_policy_url')}>{t('footer.privacy_policy')}</a>
                                </span>
                            </p>
                            <p><span className="footer-site-entry">
                                <a href={personalDataLink}>{t('footer.personal_data')}</a>
                            </span></p>
                            <address className="footer-site-entry">{t('footer.editor')}
                                <a href="mailto:utbildningsinfo@uu.se">utbildningsinfo@uu.se</a>
                            </address>
                        </article>
                    </div>
                </div>
            </div>
        </footer>
    )
}
